<template>
    <div>
        <!-- Start -->
        <div>
            <div>
                <h4 class="color-dark">
                    <strong>{{ $t(`reviews.update.stepsKickoff`) }}</strong>
                </h4>
                <p>
                    {{ reviewCycle.status.startPlan | moment("MMM DD, HH:mm") }}
                </p>
                <hr />
            </div>
            <div>
                <ul>
                    <li
                        v-show="
                            reviewCycle.peerReviewsEnabled && reviewCycle.peerNominationsEnabled
                        "
                    >
                        {{ $t(`reviews.update.stepsKickoffA1`) }}
                    </li>
                    <li v-show="reviewCycle.selfEvaluationsEnabled">
                        {{ $t(`reviews.update.stepsKickoffA2`) }}
                    </li>
                    <li v-show="reviewCycle.directReportReviewsEnabled">
                        {{ $t(`reviews.update.stepsKickoffA6`) }}
                    </li>
                    <li
                        v-show="
                            reviewCycle.peerReviewsEnabled &&
                                !reviewCycle.peerNominationsEnabled &&
                                !reviewCycle.peerSelfNominationsEnabled &&
                                reviewCycle.peerApprovalEnabled
                        "
                    >
                        {{ $t(`reviews.update.stepsKickoffA3`) }}
                    </li>
                    <li v-show="reviewCycle.managerReviewsEnabled">
                        {{ $t(`reviews.update.stepsKickoffA4`) }}
                    </li>
                    <li
                        v-show="
                            reviewCycle.peerReviewsEnabled && reviewCycle.peerSelfNominationsEnabled
                        "
                    >
                        {{ $t(`reviews.update.stepsKickoffA5`) }}
                    </li>
                    <li
                        v-show="
                            reviewCycle.peerReviewsEnabled &&
                                !reviewCycle.peerNominationsEnabled &&
                                !reviewCycle.peerApprovalEnabled &&
                                !reviewCycle.peerSelfNominationsEnabled
                        "
                    >
                        {{ $t(`reviews.update.stepsKickoffA7`) }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- Deadline for peerNominations == start of peerReviews OR start of peerApprovals -->

        <div v-if="reviewCycle.peerReviewsEnabled && reviewCycle.peerNominationsEnabled">
            <div>
                <hr />
                <h4 class="color-dark">
                    <strong>{{ $t(`reviews.update.stepsPeerNomination`) }}</strong>
                </h4>
                <p>
                    {{ reviewCycle.status.peerNominationsPlan | moment("MMM DD, HH:mm") }}
                </p>
                <hr />
            </div>
            <div>
                <ul>
                    <li v-show="reviewCycle.peerApprovalEnabled">
                        {{ $t(`reviews.update.stepsPeerApprovalA1`) }}
                    </li>
                    <li v-show="!reviewCycle.peerApprovalEnabled">
                        {{ $t(`reviews.update.stepsPeerReviewsA1`) }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- Deadline for peerApproval == start of peerReviews -->

        <div v-if="reviewCycle.peerReviewsEnabled && reviewCycle.peerApprovalEnabled">
            <div>
                <hr />
                <h4 class="color-dark">
                    <strong>{{ $t(`reviews.update.stepsPeerApproval`) }}</strong>
                </h4>
                <p>
                    {{ reviewCycle.status.peerApprovalPlan | moment("MMM DD, HH:mm") }}
                </p>
                <hr />
            </div>
            <div>
                <ul>
                    <li>
                        {{ $t(`reviews.update.stepsPeerReviewsA3`) }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- Deadline for peerReviews == managerReviews start OR process ends -->

        <div
            v-if="
                reviewCycle.peerReviewsEnabled ||
                    reviewCycle.selfEvaluationsEnabled ||
                    reviewCycle.directReportReviewsEnabled
            "
        >
            <div>
                <hr />
                <h4 class="color-dark">
                    <strong> {{ $t(`reviews.update.stepsPeerReviews`) }}</strong>
                </h4>
                <p>
                    {{ reviewCycle.status.peerReviewsPlan | moment("MMM DD, HH:mm") }}
                </p>
                <hr />
            </div>
            <div>
                <ul>
                    <li v-show="reviewCycle.peerReviewsEnabled">
                        {{ $t(`reviews.update.stepsManagerReviewsA1`) }}
                    </li>
                    <li v-show="reviewCycle.selfEvaluationsEnabled">
                        {{ $t(`reviews.update.stepsManagerReviewsA2`) }}
                    </li>
                    <li v-show="reviewCycle.directReportReviewsEnabled">
                        {{ $t(`reviews.update.stepsManagerReviewsA6`) }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- Deadline for managerReviews == start of conversations OR end of process -->

        <div v-if="reviewCycle.managerReviewsEnabled">
            <div>
                <hr />
                <h4 class="color-dark">
                    <strong>
                        {{ $t(`reviews.update.stepsManagerReviews`) }}
                    </strong>
                </h4>
                <p>
                    {{ reviewCycle.status.managerReviewsPlan | moment("MMM DD, HH:mm") }}
                </p>
                <hr />
            </div>
            <div>
                <ul>
                    <li v-show="reviewCycle.managerReviewsEnabled">
                        {{ $t(`reviews.update.stepsConversationsA1`) }}
                    </li>
                </ul>
            </div>
        </div>

        <!-- Deadline for conversations -->

        <div
            v-if="reviewCycle.managerReviewsEnabled && !reviewCycle.visibilityControlledByReviewee"
        >
            <div>
                <hr />
                <h4 class="reviewSetupHeading color-dark">
                    <strong>
                        {{ $t(`reviews.update.stepsConversations`) }}
                    </strong>
                </h4>
                <p>
                    {{ reviewCycle.status.conversationsPlan | moment("MMM DD, HH:mm") }}
                </p>
                <hr />
            </div>
            <div>
                <ul>
                    <li>
                        {{ $t(`reviews.update.stepsConversationsEndA1`) }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        reviewCycle: {
            type: Object,
            required: true,
        },
    },
};
</script>
